const EL_MESSAGE_OPTIONS_PRESET = {
  success: {
    duration: 2000,
    offset: 32,
  },
  info: {
    duration: 3000,
    offset: 32,
  },
  warning: {
    duration: 3000,
    offset: 32,
  },
  error: {
    duration: 3000,
    offset: 32,
  },
}

const getUserOptions = (message, options) => {
  const curOptions = {}
  if (typeof message === 'string') {
    curOptions.message = message
  } else {
    Object.assign(curOptions, message)
  }

  if (typeof options === 'object') {
    Object.assign(curOptions, options)
  }

  return curOptions
}

export const PatchElMessagePlugin = {
  install(Vue) {
    const _message = Vue.prototype.$message
    Vue.prototype.$elMessage = _message

    function hcMessage(message, options) {
      const curOptions = getUserOptions(message, options)
      const curType = curOptions.type || 'info'
      let finalOptions = curOptions
      if (EL_MESSAGE_OPTIONS_PRESET[curType]) {
        finalOptions = {
          ...EL_MESSAGE_OPTIONS_PRESET[curType],
          ...curOptions
        }
      }

      // 调用原生 el-message
      _message(finalOptions)
    }

    hcMessage.success = function(message, options) {
      const curOptions = getUserOptions(message, options)
      curOptions.type = 'success'
      hcMessage(curOptions)
    }
    hcMessage.info = function(message, options) {
      const curOptions = getUserOptions(message, options)
      curOptions.type = 'info'
      hcMessage(curOptions)
    }
    hcMessage.warning = function(message, options) {
      const curOptions = getUserOptions(message, options)
      curOptions.type = 'warning'
      hcMessage(curOptions)
    }
    hcMessage.error = function(message, options) {
      const curOptions = getUserOptions(message, options)
      curOptions.type = 'error'
      hcMessage(curOptions)
    }

    // 覆盖原生的 $message
    Vue.prototype.$message = hcMessage
  }
}
